import { Capacitor } from '@capacitor/core';

export const isNativeMobilePlatform = () => {
  const platform = Capacitor.getPlatform();
  return Capacitor.isNativePlatform() && (platform === 'ios' || platform === 'android');
};
